import type { FaireProductEntity } from "../../entity_types/product";

export const p_4hzqj2eagv: FaireProductEntity = {
  token: "p_4hzqj2eagv",
  type: "product",
  name: "Original Passata Sauce",
  brandToken: "b_cswuxgoe1w",
  brandName: "Bona Furtuna",
  imageUrl: "https://cdn.faire.com/fastly/f923d4af1a928649d857faa66e11b3d6b5e8a0e8e71d5152c19fc39a4921538e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b17860f3655b972326a6dce9e27b468826cbae0c97af3eddd7441a90ab32ea0d.jpeg",
    "https://cdn.faire.com/fastly/984a073f98ad5e58a78b95adc6138366da08f6a9714d25aa30161ba8b4ad2624.jpeg",
    "https://cdn.faire.com/fastly/84db0d8b2d30f1d31148df468ce345948dd91df80e4eb9cc89534df93433175c.jpeg",
    "https://cdn.faire.com/fastly/3f7b7046c361cbb7dba3133a92ac5cd874988dab96057762600fff7c9e4b5a84.jpeg",
    "https://cdn.faire.com/fastly/54891c308557bb953020d4fba153cf8ed8441b6569e7a72d7828cd6a8f8874c9.jpeg"
  ],
  priceDollars: 6.48,
  description: "Made with 100% organic Corleonese heirloom tomatoes, our Italian tomato Passata sauce captures the purest expression of vine-ripened tomatoes. An Italian pantry staple, embrace the pure sun-warmed flavors of raw organic tomato passata.\n",
  tags: [],
  msrpDollars: 12.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:21.327Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
